import { createRoute, type AnyRoute } from "@tanstack/react-router";
import { BadgePercent } from "lucide-react";

import type { FeatureModule } from "@/features/types";
import { guarded } from "@/lib/auth";

import { CommissionsPage, type CommissionsTab } from "./pages/CommissionsPage";

export const commissionsModule: FeatureModule = {
  key: "commissions",
  nav: {
    label: "Commissions",
    icon: BadgePercent,
    to: "/commissions",
    requires: "commissions.read",
    order: 100,
    group: "Revenue",
  },
  routes: (rootRoute) => [
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/commissions",
      component: guarded("commissions.read", CommissionsPage),
      validateSearch: (search: Record<string, unknown>): { tab?: CommissionsTab } => {
        const tab = search.tab;
        return tab === "report" ||
          tab === "contracts" ||
          tab === "ledger" ||
          tab === "collections" ||
          tab === "paid" ||
          tab === "admin" ||
          tab === "how-to"
          ? { tab }
          : {};
      },
    }),
  ] as unknown as AnyRoute[],
};
